import axios from 'axios';
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
}
// 创建一个 Axios 实例
const axiosInstance = axios.create({
  // baseURL: 'https://test-ssg-recruiting-api.seasungames.cn/api/ssg_recruiting/v1/api-platform/v1/',
  // baseURL: 'https://test-ssg-recruiting-api.seasungames.cn/api/ssg_recruiting_cn/v1/api-platform/v1/',
  baseURL: DEPLOY_ENV === 'master' ? 'https://ssg-recruiting-api.seasungames.cn/' : 'https://test-ssg-recruiting-api.seasungames.cn/',
  //baseURL: 'https://ssg-recruiting-api.seasungames.cn/',

  // baseURL: 'https://ssg-recruiting-api.seasungames.com/api/ssg_recruiting/v1/api-platform/v1/',

  timeout: 120000, // 请求超时时间

  withCredentials: true, // 允许携带 Cookie
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  config => {
    // 从浏览器 Cookie 中获取所需的 QA_XY_TOKEN 和 QA_XY_TOKEN_
    // const qaToken = getCookie('QA_XY_TOKEN');
    // const qaToken_ = getCookie('QA_XY_TOKEN_');

    // // 将这些 Cookie 添加到请求头中
    // if (qaToken && qaToken_) {
    //   config.headers.Cookie = `QA_XY_TOKEN=${qaToken}; QA_XY_TOKEN_=${qaToken_}`;
    // }

    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  response => {
    // console.log(response, 'response');
    // 处理响应数据
    if (response.data.code === 1 || (response.status === 200 && !response.data.code) || (response.status === 200 && response.data.code === 200)) {
      return response.data;
    } else {
      return Promise.reject(response.data);
    }
  },

  error => {
    console.log(error, 'error');
    // 处理响应错误
    if (error.response) {
      // 请求已发出，但服务器响应了状态码不在 2xx 范围内的内容
      switch (error.response.code) {
        case 403:
          // 禁止访问
          console.error('禁止访问');
          break;
        case 500:
          // 服务器内部错误
          console.error('服务器内部错误');
          break;
        default:
          console.error('其他错误');
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('请求已发出，但没有收到响应', error.request);
    } else {
      // 其他错误
      console.error('其他错误', error.message);
    }
    return Promise.reject(error.response.data);
  }
);

// 封装 GET 请求
const get = (url, params, config = {}) => {
  return axiosInstance.get(url, { params, ...config });
};

// 封装 POST 请求
const post = (url, data, config = {}) => {
  return axiosInstance.post(url, data, config);
};

// 封装 PUT 请求
const put = (url, data, config = {}) => {
  return axiosInstance.put(url, data, config);
};

// 封装 DELETE 请求
const deleteRequest = (url, config = {}) => {
  return axiosInstance.delete(url, config);
};

export default {
  get,
  post,
  put,
  delete: deleteRequest // 使用 delete 作为属性名会报错，所以使用 deleteRequest
};
